/*********************************************************************
 ********************  PERMISSIONS DEFINITION  ***********************
 *********************************************************************/

export const USER_EDIT = 'user-edit';
export const PERMISSIONS_EDIT = 'permissions-edit';
export const ORDER_SERVICE_EDIT = 'order-service-edit';
export const UNBLOCK_DRIVE_FILES = 'unblock-drive-files';
